import { render, staticRenderFns } from "./UserNotificationSetting.vue?vue&type=template&id=14030604&"
import script from "./UserNotificationSetting.vue?vue&type=script&lang=js&"
export * from "./UserNotificationSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports